/**
 * Revamp Cart Drawer — Cross-sell & Shipping Progress
 * Handles:
 *  1. Loading cross-sell product recommendations
 *  2. Cross-sell "add to cart" buttons
 *  3. Dynamic shipping-progress bar updates (after AJAX cart changes)
 */

(function () {
  'use strict';

  /* ── Capture native fetch before any interceptors load ── */
  var nativeFetch = window.fetch.bind(window);

  /* ── Constants ── */
  var FREE_SHIPPING = 4900;  // in cents
  var GIFT_THRESHOLD = 8900;
  var SURPRISE_THRESHOLD = 11900;

  /* ── Feature flags ── */
  var GIFTS_ENABLED = false;  // controls €89 sample gift only — surprise gift (€119) always runs
  var SHOPIFY_ROOT = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';

  /* ── Free gift variant IDs ── */
  var FREE_GIFT_VARIANT_SAMPLE = 53603868279111;    // unlocked at gift tier (€89)
  var SURPRISE_VARIANTS = [
    { id: 53603719414087, label: 'Zitrone', img: 'https://cdn.shopify.com/s/files/1/0849/8344/7879/files/zitrone.png?v=1772984089' },
    { id: 53794925609287, label: 'Orange',  img: 'https://cdn.shopify.com/s/files/1/0849/8344/7879/files/Orange.png?v=1772984083' },
    { id: 53794927575367, label: 'Berry',   img: 'https://cdn.shopify.com/s/files/1/0849/8344/7879/files/Berry.png?v=1772984078' }
  ];
  var SURPRISE_VARIANT_IDS = SURPRISE_VARIANTS.map(function(v) { return v.id; });
  var syncingFreeGifts = false;
  var flavorPickerDeclined = false;

  /* ── Helpers ── */
  function money(cents) {
    // Format cents into €X,XX  (German locale)
    var euros = (cents / 100).toFixed(2).replace('.', ',');
    return '€' + euros;
  }

  /* ── XHR helpers — bypass all fetch interceptors (Appstle, popup, etc.) ── */
  function xhrPost(url, data) {
    return new Promise(function (resolve, reject) {
      var xhr = new XMLHttpRequest();
      xhr.open('POST', url, true);
      xhr.setRequestHeader('Content-Type', 'application/json');
      xhr.setRequestHeader('Accept', 'application/json');
      xhr.onload = function () {
        var resp = JSON.parse(xhr.responseText || '{}');
        if (xhr.status >= 400) { reject(resp); } else { resolve(resp); }
      };
      xhr.onerror = function () { reject(new Error('XHR error')); };
      xhr.send(JSON.stringify(data));
    });
  }

  function xhrGet(url) {
    return new Promise(function (resolve, reject) {
      var xhr = new XMLHttpRequest();
      xhr.open('GET', url, true);
      xhr.setRequestHeader('Accept', 'application/json');
      xhr.onload = function () {
        var resp = JSON.parse(xhr.responseText || '{}');
        if (xhr.status >= 400) { reject(resp); } else { resolve(resp); }
      };
      xhr.onerror = function () { reject(new Error('XHR error')); };
      xhr.send();
    });
  }

  /* ── Free Gift Sync ── */
  function syncFreeGifts(totalCents) {
    if (syncingFreeGifts) return;
    syncingFreeGifts = true;

    var shouldHaveSample = totalCents >= GIFT_THRESHOLD;
    var shouldHaveSurprise = totalCents >= SURPRISE_THRESHOLD;

    xhrGet(SHOPIFY_ROOT + 'cart.json')
      .then(function (cart) {
        var sampleItem = null, surpriseItem = null;
        cart.items.forEach(function (item) {
          if (item.variant_id == FREE_GIFT_VARIANT_SAMPLE) sampleItem = item;
          if (SURPRISE_VARIANT_IDS.indexOf(item.variant_id) !== -1) surpriseItem = item;
        });

        var ops = [];

        // Sample gift (€89) only when GIFTS_ENABLED
        if (GIFTS_ENABLED) {
          if (shouldHaveSample && !sampleItem) {
            ops.push(xhrPost(SHOPIFY_ROOT + 'cart/add.js', { items: [{ id: FREE_GIFT_VARIANT_SAMPLE, quantity: 1, properties: { _free_gift: 'sample' } }] }));
          } else if (!shouldHaveSample && sampleItem) {
            ops.push(xhrPost(SHOPIFY_ROOT + 'cart/change.js', { id: sampleItem.key, quantity: 0 }));
          }
        }

        // Surprise gift (€119) always runs regardless of GIFTS_ENABLED
        if (shouldHaveSurprise && !surpriseItem) {
          showFlavorPicker();
        } else if (!shouldHaveSurprise && surpriseItem) {
          flavorPickerDeclined = false;
          ops.push(xhrPost(SHOPIFY_ROOT + 'cart/change.js', { id: surpriseItem.key, quantity: 0 }));
        }

        if (ops.length === 0) { syncingFreeGifts = false; return; }

        Promise.all(ops)
          .then(function () {
            var drawer = document.querySelector('m-cart-drawer');
            if (drawer && typeof drawer.onCartDrawerUpdate === 'function') drawer.onCartDrawerUpdate();
          })
          .catch(function () {})
          .finally(function () { syncingFreeGifts = false; });
      })
      .catch(function () { syncingFreeGifts = false; });
  }

  /* ── Cross-sell: Add to cart ── */
  function initCrossSellButtons() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.revamp-cs-add-btn');
      if (!btn) return;
      e.preventDefault();

      var variantId = btn.getAttribute('data-variant-id');
      if (!variantId) return;

      btn.classList.add('is-loading');

      var body = JSON.stringify({
        items: [{ id: parseInt(variantId, 10), quantity: 1 }],
      });

      fetch(SHOPIFY_ROOT + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: body,
      })
        .then(function (r) { return r.json(); })
        .then(function () {
          // Re-render the drawer via the existing theme mechanism
          var drawer = document.querySelector('m-cart-drawer');
          if (drawer && typeof drawer.onCartDrawerUpdate === 'function') {
            drawer.onCartDrawerUpdate();
          }
          // Also open the drawer if not already open
          if (drawer && typeof drawer.open === 'function') {
            drawer.open();
          }
          // Re-render the standalone section (if present on the page)
          var section = document.querySelector('m-revamp-cart-section-items');
          if (section && typeof section.onCartUpdate === 'function') {
            section.onCartUpdate();
          }
          // Update cart count + shipping progress
          fetch(SHOPIFY_ROOT + 'cart.json')
            .then(function (r) { return r.json(); })
            .then(function (cart) {
              if (drawer && typeof drawer.updateCartCount === 'function') {
                drawer.updateCartCount(cart.item_count);
              }
              updateShippingProgress(cart.original_total_price || cart.total_price);
            });
        })
        .catch(function (err) {
          console.error('Cross-sell ATC error:', err);
        })
        .finally(function () {
          btn.classList.remove('is-loading');
        });
    });
  }

  /* ── Shipping Progress Bar — dynamic update ── */
  function updateShippingProgress(totalCents) {
    // Update ALL shipping banners on the page (drawer + standalone section)
    var banners = document.querySelectorAll('[data-revamp-shipping-banner]');
    if (!banners.length) return;

    // Piecewise progress: 0→33% for free shipping, 33→66% for gift, 66→100% for surprise
    var overallPct;
    if (totalCents >= SURPRISE_THRESHOLD) {
      overallPct = 100;
    } else if (totalCents >= GIFT_THRESHOLD) {
      overallPct = 66 + ((totalCents - GIFT_THRESHOLD) / (SURPRISE_THRESHOLD - GIFT_THRESHOLD)) * 34;
    } else if (totalCents >= FREE_SHIPPING) {
      overallPct = 33 + ((totalCents - FREE_SHIPPING) / (GIFT_THRESHOLD - FREE_SHIPPING)) * 33;
    } else {
      overallPct = (totalCents / FREE_SHIPPING) * 33;
    }
    overallPct = Math.min(100, Math.round(overallPct));

    // Determine current tier text
    var remainingHTML, topText;
    if (totalCents < FREE_SHIPPING) {
      var remFree = FREE_SHIPPING - totalCents;
      remainingHTML = 'Noch <strong>' + money(remFree) + '</strong> bis zum <strong>kostenlosen Versand</strong>';
      topText = 'Glückwunsch! Deine Artikel warten auf dich!';
    } else if (totalCents < GIFT_THRESHOLD) {
      var remGift = GIFT_THRESHOLD - totalCents;
      remainingHTML = GIFTS_ENABLED
        ? 'Noch <strong>' + money(remGift) + '</strong> bis zur <strong>Gratisprobe</strong>'
        : 'Noch <strong>' + money(remGift) + '</strong> bis zu weiteren <strong>10% Rabatt</strong>';
      topText = 'Kostenloser Versand freigeschaltet! 🎉';
    } else if (totalCents < SURPRISE_THRESHOLD) {
      var remSurprise = SURPRISE_THRESHOLD - totalCents;
      remainingHTML = 'Noch <strong>' + money(remSurprise) + '</strong> bis zum <strong>gratis Elektrolyt-Vorrat (30x)</strong>';
      topText = GIFTS_ENABLED ? 'Gratisprobe freigeschaltet! 🎁' : '10% Rabatt freigeschaltet! 🎉';
    } else {
      remainingHTML = '<strong>Alle Vorteile</strong> sind aktiviert! 🎉🎁';
      topText = 'Alle Vorteile freigeschaltet! 🎉🎁';
    }

    var thresholds = [FREE_SHIPPING, GIFT_THRESHOLD, SURPRISE_THRESHOLD];

    banners.forEach(function (banner) {
      // Update fill bar
      var fill = banner.querySelector('[data-progress-fill]');
      if (fill) fill.style.width = overallPct + '%';

      // Update text
      var textEl = banner.querySelector('[data-shipping-remaining-text]');
      var topEl = banner.querySelector('.revamp-shipping-banner__top');
      if (textEl) textEl.innerHTML = remainingHTML;
      if (topEl) topEl.textContent = topText;

      // Update step reached states
      var steps = banner.querySelectorAll('.revamp-progress-step');
      steps.forEach(function (step, i) {
        step.classList.toggle('is-reached', totalCents >= thresholds[i]);
      });
    });

    // Update ALL shipping cost elements in footers
    var shippingCosts = document.querySelectorAll('[data-cart-shipping-cost]');
    shippingCosts.forEach(function (el) {
      el.textContent = totalCents >= FREE_SHIPPING ? 'Kostenlos' : money(399);
    });

    syncFreeGifts(totalCents);
  }

  /* ── Load Cross-Sell Recommendations via Section Rendering API ── */
  var CROSS_SELL_SECTION_ID = 'cart-drawer-cross-sells';
  var MAX_CROSS_SELLS = 4;
  var crossSellLoading = false;

  /**
   * Get unique product IDs from the cart.
   * First tries DOM elements, then falls back to cart.json.
   */
  function getCartProductIds() {
    // Try DOM first (faster, no network)
    var drawer = document.querySelector('m-cart-drawer');
    var cartItems = drawer ? drawer.querySelectorAll('[data-product-id]') : [];
    if (cartItems.length > 0) {
      var ids = [];
      cartItems.forEach(function (el) {
        var pid = String(el.getAttribute('data-product-id'));
        if (pid && ids.indexOf(pid) === -1) ids.push(pid);
      });
      return Promise.resolve(ids);
    }

    // Fallback: fetch cart.json (reliable after AJAX re-renders)
    return fetch(SHOPIFY_ROOT + 'cart.json')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var ids = [];
        (cart.items || []).forEach(function (item) {
          var pid = String(item.product_id);
          if (pid && ids.indexOf(pid) === -1) ids.push(pid);
        });
        return ids;
      })
      .catch(function () { return []; });
  }

  /**
   * Fetch recommendations for a single product via Section Rendering API.
   * Tries default (related) intent first. If empty, tries complementary.
   */
  function fetchRecsForProduct(productId) {
    var baseUrl = SHOPIFY_ROOT + 'recommendations/products?product_id=' + productId
      + '&limit=6&section_id=' + CROSS_SELL_SECTION_ID;

    return fetch(baseUrl)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var items = parseRecsHTML(html);
        // If default intent returned nothing, try complementary
        if (items.length === 0) {
          return fetch(baseUrl + '&intent=complementary')
            .then(function (r2) { return r2.text(); })
            .then(function (html2) { return parseRecsHTML(html2); })
            .catch(function () { return []; });
        }
        return items;
      })
      .catch(function () { return []; });
  }

  function parseRecsHTML(html) {
    var parser = new DOMParser();
    var doc = parser.parseFromString(html, 'text/html');
    var nodes = doc.querySelectorAll('.revamp-cs-item');
    return Array.prototype.slice.call(nodes);
  }

  function loadCrossSellProducts() {
    var container = document.querySelector('[data-cross-sell-items]');
    if (!container) return;

    // Prevent concurrent loads
    if (crossSellLoading) return;
    crossSellLoading = true;

    getCartProductIds()
      .then(function (cartProductIds) {
        if (cartProductIds.length === 0) {
          container.innerHTML = '';
          crossSellLoading = false;
          return;
        }

        // Fetch recommendations for ALL cart products
        var fetchPromises = cartProductIds.map(function (pid) {
          return fetchRecsForProduct(pid);
        });

        return Promise.all(fetchPromises).then(function (results) {
          var seenIds = {};
          var allItems = [];

          // Flatten & deduplicate, skip products already in cart
          results.forEach(function (nodes) {
            nodes.forEach(function (node) {
              var pid = node.getAttribute('data-cs-product-id');
              if (!pid) return;
              if (seenIds[pid]) return;
              if (cartProductIds.indexOf(pid) !== -1) return;
              seenIds[pid] = true;
              allItems.push(node.outerHTML);
            });
          });

          // Take only the first N items
          var finalItems = allItems.slice(0, MAX_CROSS_SELLS);
          container.innerHTML = finalItems.length > 0 ? finalItems.join('') : '';
        });
      })
      .catch(function (err) {
        console.error('Cross-sell load error:', err);
      })
      .finally(function () {
        crossSellLoading = false;
      });
  }

  /* ── Fetch cart and refresh everything ── */
  function refreshCartState() {
    xhrGet(SHOPIFY_ROOT + 'cart.json')
      .then(function (cart) {
        updateShippingProgress(cart.original_total_price || cart.total_price);
      })
      .catch(function () {});
  }

  /* ── Flavor Picker Modal (€119 surprise gift) ── */
  function showFlavorPicker() {
    if (flavorPickerDeclined) return;
    if (document.querySelector('.revamp-flavor-overlay')) return;

    var overlay = document.createElement('div');
    overlay.className = 'revamp-flavor-overlay';
    overlay.innerHTML =
      '<div class="revamp-flavor-modal">' +
        '<button class="revamp-flavor-modal__close" aria-label="Schließen">&times;</button>' +
        '<div class="revamp-flavor-modal__icon">🎁</div>' +
        '<p class="revamp-flavor-modal__title">Gratis Elektrolyt-Vorrat (30x) freigeschaltet!</p>' +
        '<p class="revamp-flavor-modal__subtitle">Wähle deinen Geschmack:</p>' +
        '<div class="revamp-flavor-modal__options">' +
          SURPRISE_VARIANTS.map(function(v) {
            return '<button class="revamp-flavor-btn" data-variant="' + v.id + '">' +
              '<img class="revamp-flavor-btn__img" src="' + v.img + '" alt="' + v.label + '" width="40" height="40" loading="lazy">' +
              v.label +
            '</button>';
          }).join('') +
        '</div>' +
      '</div>';

    overlay.querySelector('.revamp-flavor-modal__close').addEventListener('click', function () {
      overlay.remove();
      flavorPickerDeclined = true;
    });

    overlay.querySelectorAll('.revamp-flavor-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var variantId = parseInt(btn.getAttribute('data-variant'), 10);
        overlay.querySelectorAll('.revamp-flavor-btn').forEach(function (b) { b.disabled = true; });
        btn.classList.add('is-loading');
        xhrPost(SHOPIFY_ROOT + 'cart/add.js', {
          items: [{ id: variantId, quantity: 1, properties: { _free_gift: 'surprise' } }]
        }).then(function () {
          overlay.remove();
          var drawer = document.querySelector('m-cart-drawer');
          if (drawer && typeof drawer.onCartDrawerUpdate === 'function') drawer.onCartDrawerUpdate();
        }).catch(function () {
          overlay.querySelectorAll('.revamp-flavor-btn').forEach(function (b) { b.disabled = false; });
          btn.classList.remove('is-loading');
        });
      });
    });

    document.body.appendChild(overlay);
  }

  /* ── Gift tier icon swap (10% badge when GIFTS_ENABLED = false) ── */
  function updateGiftTierIcon() {
    if (GIFTS_ENABLED) return;
    document.querySelectorAll('[data-revamp-shipping-banner]').forEach(function (banner) {
      var steps = banner.querySelectorAll('.revamp-progress-step');
      var giftStep = steps[1]; // index 1 = €89 tier
      if (!giftStep) return;
      var icon = giftStep.querySelector('.revamp-step-icon');
      if (!icon || icon.querySelector('.revamp-discount-badge')) return;
      var img = icon.querySelector('img');
      if (!img) return;
      var badge = document.createElement('span');
      badge.className = 'revamp-discount-badge';
      badge.innerHTML = '<span style="font-size:9px;font-weight:900;letter-spacing:-0.5px;">10%</span><span style="font-size:6px;font-weight:700;letter-spacing:0.2px;">Disc.</span>';
      badge.style.cssText = 'display:flex;flex-direction:column;align-items:center;justify-content:center;gap:1px;font-family:Arial,sans-serif;color:#1a1a1a;line-height:1;';
      icon.replaceChild(badge, img);
    });
  }

  /* ── Listen for cart updates to refresh progress + cross-sells ── */
  function listenForCartUpdates() {
    // Patch onCartDrawerUpdate — fires only on real cart re-renders, not every DOM change
    var drawer = document.querySelector('m-cart-drawer');
    if (drawer && typeof drawer.onCartDrawerUpdate === 'function') {
      var orig = drawer.onCartDrawerUpdate.bind(drawer);
      drawer.onCartDrawerUpdate = function () {
        var result = orig.apply(this, arguments);
        setTimeout(function () {
          refreshCartState();
          loadCrossSellProducts();
          updateGiftTierIcon();
        }, 800);
        return result;
      };
    }

    // Minimog pub/sub events as supplementary triggers
    if (window.MinimogEvents && window.MinimogTheme) {
      MinimogEvents.subscribe(MinimogTheme.pubSubEvents.cartUpdate, function (data) {
        if (data && typeof data.total_price !== 'undefined') {
          updateShippingProgress(data.original_total_price || data.total_price);
        }
        setTimeout(loadCrossSellProducts, 500);
      });

      MinimogEvents.subscribe(MinimogTheme.pubSubEvents.openCartDrawer, function () {
        loadCrossSellProducts();
        refreshCartState();
        updateGiftTierIcon();
      });
    }
  }

  /* ── Init ── */
  function init() {
    initCrossSellButtons();
    listenForCartUpdates();
    loadCrossSellProducts();
    updateGiftTierIcon();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
